import React from 'react'
import PropTypes from 'prop-types'
import { Box, Typography } from '@material-ui/core'
export function TabContainer (props) {
  return (
    <Typography component='div' style={{ padding: 8 * 3 }}>
      {props.children}
    </Typography>
  )
}
TabContainer.propTypes = {
  children: PropTypes.node.isRequired
}
export function TabPanel (props) {
  const { children, headerTabs, subHeaderTabs1, index, ...other } = props
  return (
    <Typography
      component='div'
      role='tabpanel'
      hidden={headerTabs !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}>
      <Box p={3}>{children}</Box>
    </Typography>
  )
}
TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  headerTabs: PropTypes.any.isRequired,
  subHeaderTabs1: PropTypes.any.isRequired
}
